export const iconFontAwesomeCampingFaucetDrip = (
	<i className="fa-solid fa-faucet-drip"></i>
);
